import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

/**
 * https://github.com/angular/angular/issues/10643
 * https://github.com/angular/angular/issues/12200
 */
if (environment.production) {
  enableProdMode();
  console.log('Enable prod mode');
} else {
  localStorage.setItem('enable-console', 'true');
}

platformBrowserDynamic().bootstrapModule(AppModule);

